import { SBTranslate } from "i18n";
import { SBBox, SBSelect } from "modules/Commons";
import { RecommendationMethodology } from "modules/InventoryConfig/models/recommendationMethodology";
import { useContext, useEffect, useState } from "react";
import { TipsContext } from "views/ConfigsView/ConfigTips";

const ConfigRecommendationMethodology = ({ value, onUpdate }: ConfigRecommendationMethodologyProps) => {
	const tipsContext = useContext(TipsContext);

	const [recommendationMethodology, setRecommendationMethodology] = useState<RecommendationMethodology | null>(value ?? null);

	const RecommendationMethodologyValues = [
		{ text: SBTranslate("csl"), value: RecommendationMethodology.CSL, tipsContext: "RecommendationMethodologyCSL" },
		{ text: SBTranslate("doh"), value: RecommendationMethodology.DOH, tipsContext: "RecommendationMethodologyDOH" },
	];

	const updateRecommendationMethodology = (value: number) => {
		tipsContext.showTip(RecommendationMethodologyValues.find(r => r.value === value)?.tipsContext ?? "");
		setRecommendationMethodology(value);
	};

	useEffect(() => {
		onUpdate(recommendationMethodology);
	}, [recommendationMethodology]);

	return (
		<SBBox>
			<SBSelect
				fullWidth
				getText={item => item.text}
				getValue={item => item.value}
				onChange={(event) => updateRecommendationMethodology(Number(event.target.value))}
				value={recommendationMethodology ?? RecommendationMethodology.CSL}
				items={RecommendationMethodologyValues}
			></SBSelect>
		</SBBox>
	);
};

interface ConfigRecommendationMethodologyProps {
	value: RecommendationMethodology | null;
	onUpdate: (v: RecommendationMethodology | null) => void;
}
export default ConfigRecommendationMethodology;
